import styled from '@emotion/styled'
import { ModalContent } from '../../components/panels'
import * as constants from '../../styles/constants'
import { isNil } from 'lodash-es'

const handleModalDialogBreakpoint = (size?: string) => {
  switch (size) {
    case 'medium':
      return '1140px'
    case 'big':
      return '1280px'
    default:
      return '1000px'
  }
}

export const Content = styled(ModalContent)<{ size?: 'medium' | 'big' }>`
  width: ${({ size }) => handleModalDialogBreakpoint(size)};
  border-bottom: 2px solid ${constants.CORE_PRIMARY_1};
`

export const FieldsContainer = styled.fieldset`
  border: 0;
  &:last-child {
    margin-bottom: 0;
  }

  & > * {
    margin-bottom: 19px;
  }
`

export const TableHeader = styled.div`
  display: flex;
  flex-direction: row;
  padding: 12px 10px;
  font-weight: ${constants.FontWeight.SemiBold};
  border-top: 2px solid ${constants.CORE_PRIMARY_1};
  border-bottom: 2px solid ${constants.CORE_PRIMARY_1};
`

export const TableRows = styled.div`
  height: 300px;
  overflow: overlay;
  margin-bottom: 10px;
  & > div:nth-child(even) {
    background-color: ${constants.CORE_PRIMARY_1};
  }
`

export const TableRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 12px 10px;
`

export const TableCell = styled.div<{ flex?: number; left?: boolean; dataTestId?: string }>`
  font-size: 12px;
  margin: 0 10px 0 0;
  flex: ${props => (!isNil(props.flex) ? `${props.flex} 0 0` : '')};
  display: flex;
  flex-direction: row;
  justify-content: ${props => (props.left ? 'flex-start' : 'flex-end')};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`

export const TableCellInput = styled(TableCell)`
  overflow: visible;
`
